export default "__VITE_ASSET__34bf10ac__"